import DataObjectsTemplate from "../../../../datasets/data_object_templates";
import addDepositAmtToCDList from "./add_deposit_amt_to_CDList";
import addToSavingsTranArr from "./add_to_savings_tran_arr";
import addTransferAmtsToYearArr from "./add_transfer_amts_to_yearArr";
import applyTransferAmtToCDList from "./apply_transfer_amt_to_CDList";

export const createSavingArrElement = (savingInfo, newSavingsArrSw, currentGameDate, 
        currentSavingsElement, cashChgAmt, currentPrice, gameID, CDList ) => {

    let savingsArrObj = {};
    let accountBalance = 0;
    let accountInterest = 0;
    let savingsClass = savingInfo.savingsClass;
   
    if (newSavingsArrSw === true || savingInfo.createNewElementSw === true){
        let savingArrayObjTemplate = 
            DataObjectsTemplate.find(elem => elem.dataType === "savingsArrObj").savingsInfo;
        savingsArrObj = JSON.parse(JSON.stringify(savingArrayObjTemplate));
        let typeSavingsObj = {}
        if (savingsClass === "bank"){
            typeSavingsObj = 
                DataObjectsTemplate.find(elem => elem.dataType === "savingsArrObjBank").savingsInfo;
            savingsArrObj = {...savingsArrObj, ...typeSavingsObj};
        }
        
        savingsArrObj.savingsType = savingInfo.savingsType;
        savingsArrObj.savingsClass = savingInfo.savingsClass;
        savingsArrObj.startDate = currentGameDate;
        if (savingsClass === "bank"){
            savingsArrObj.interestRate = savingInfo.intRate;
            savingsArrObj.intRateStartDate = currentGameDate;
        }
        newSavingsArrSw = true;
    }else{
        savingsArrObj = currentSavingsElement;
    }
    if (savingInfo.currentPrice){
        currentPrice = savingInfo.currentPrice;
    }
   
    let tranNbr = 0;
    if (currentSavingsElement.savingTotals){
        const totalObj = savingsArrObj.savingTotals;
        accountBalance = totalObj.totalSavings;
        accountInterest = totalObj.totalInterest;
        tranNbr = totalObj.nbrTrans;
    }
    
    let actualDepositAmt = +savingInfo.oneTimeDepositAmt;
    let tranArr = [];
    if (+savingInfo.oneTimeDepositAmt > 0){
        tranNbr = addToSavingsTranArr("Deposit", actualDepositAmt, currentGameDate, tranNbr, currentPrice,
            tranArr );
        accountBalance += +savingInfo.oneTimeDepositAmt; 
        cashChgAmt = +savingInfo.oneTimeDepositAmt * -1;
    }
    if (+savingInfo.newTransferAmt > 0){
        const newTransferAmt = savingInfo.newTransferAmt * -1;
        addToSavingsTranArr("Withdrawal", newTransferAmt, currentGameDate, tranNbr,
            currentPrice, tranArr);
        cashChgAmt += (+savingInfo.newTransferAmt - +savingInfo.newTransferFee).toFixed(2);
        accountBalance += +newTransferAmt;
        // subtracting interest to get 'true balance' and determine if transfer has depleted the account balance
        if (savingsArrObj.savingsType !== "CD" && savingsClass === "bank"){
            accountBalance -= +accountInterest;
        }
        if (accountBalance === 0){
            savingsArrObj.closedDate = currentGameDate;
            // adding interest to cashChg because it was excluded in initial transfer for CDs
            if (savingsArrObj.savingsType === "CD"){
                cashChgAmt += +accountInterest;
            }
        }    
    }
    
    savingsArrObj.monthlyDepositAmt = savingInfo.monthlyDepositAmt;
    if (savingInfo.savingsType === "CD"){
        if (+savingInfo.oneTimeDepositAmt > 0){
            addDepositAmtToCDList(CDList, savingInfo.oneTimeDepositAmt, savingInfo.autoRollover, 
                currentGameDate);
        }
        //  even if transfer amount is zero, this is required to update the autoRollover for existing CDs
        const newCDList = applyTransferAmtToCDList(savingInfo.newTransferAmt, CDList);
        if (savingsArrObj.CDList){
            savingsArrObj.CDList = newCDList;
        }else{
            savingsArrObj = {...savingsArrObj, CDList: newCDList};
        }
    }
   
    //  Transfer Amt & Transfer Fee already taken out of totalDeposited 
    if (+savingInfo.newTransferFee > 0 || +savingInfo.newTransferAmt > 0){
        const gameYear = currentGameDate.split('-')[0];
        if (!savingsArrObj.yearArr){
            savingsArrObj = {...savingsArrObj, yearArr: []};
        }
        savingsArrObj.yearArr = addTransferAmtsToYearArr(gameYear, savingsArrObj.savingsClass,
            savingsArrObj.yearArr, savingInfo.newTransferFee, savingInfo.newTransferAmt
        )
    }
    const tranArrObj = {gameID: gameID, savingsType: savingsArrObj.savingsType, tranArr: tranArr};
    const returnObj = {savingsArrObj: savingsArrObj,  tranArrObj: tranArrObj, newSavingsArrSw: newSavingsArrSw,
        cashChgAmt: cashChgAmt}
    return returnObj;
}

export default createSavingArrElement;